import { useAtom } from "jotai/index";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import StatisticsVisualizationModule from "@/module/service-configs-module/statistics-visualization-module/statistics-visualization-module";
import { headerTitle } from "@/store/store";

const StatanalyticsPage = () => {
  const { t } = useTranslation();

  const [, setHeaderTitle] = useAtom(headerTitle);
  useEffect(() => {
    setHeaderTitle(t("statanalytics"));
  }, [setHeaderTitle, t]);

  return <StatisticsVisualizationModule />;
};

export default StatanalyticsPage;
